import axios from 'axios';
import { QuestionResponse } from './QuestionStore';

const API_BASE_URL = '/api/tokens';

export const QuestionnaireService = {
    getNextQuestion: async (tokenId: string): Promise<QuestionResponse> => {
        const response = await axios.get(`${API_BASE_URL}/${tokenId}/questions`);
        return response.data;
    },

    submitAnswer: async (tokenId: string, questionID: string, answer: string): Promise<QuestionResponse> => {
        const response = await axios.patch(`${API_BASE_URL}/${tokenId}/questions`, {
            [questionID]: answer
        }, {
            timeout: 5000
        });
        return response.data;
    }
};
